<template>
  <div>
    <v-row>
      <v-col cols="12">
        <booking-resource-sheet
          class="pa-4"
          :resource="resource"
          rounded
          small
        />
      </v-col>
    </v-row>
    <component
      :is="getComponentByType()"
      v-model="form"
      :readonly="readonly"
      :errors="errors"
      :step="resource.step || ''"
      @input="emitter"
      @update-prop="updateProp(...arguments)"
    />

    <v-row>
      <v-col cols="12">
        <v-textarea
          v-model="form.info"
          name="info"
          :rows="4"
          :counter="400"
          :label="$t('ITEM.ADDITIONAL_INFO')"
          :readonly="readonly"
          :rules="getRulesByName('info')"
          :error-messages="errors.info"
          outlined
          @input="updateValue('info', $event)"
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { dateFormat } from '@/modules/_global/filters';
import { DAY, HOUR } from '@/modules/booking_schedule/common/block_types';
import { maxLength } from '@/modules/_global/variables/rules';
import formEditable from '@/modules/_global/mixins/form-editable';
import BookingResourceSheet from '@/modules/booking_reservations/components/BookingResourceSheet.vue';

export default {
  name: 'BlockForm',

  filters: {
    dateFormat
  },

  components: {
    BookingResourceSheet,
    BlockDayForm: () => import('./BlockDayForm.vue'),
    BlockHourForm: () => import('./BlockHourForm.vue')
  },

  mixins: [formEditable],

  props: {
    resource: {
      type: Object,
      required: true
    },
    blockType: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: {
        created_at: null
      },
      rules: {
        info: [maxLength(400)]
      }
    };
  },

  computed: {
    ...mapGetters(['loading'])
  },

  mounted() {},

  methods: {
    getComponentByType(type = this.blockType) {
      switch (type.id) {
        case DAY:
          return 'BlockDayForm';
        case HOUR:
          return 'BlockHourForm';

        default:
          throw new Error('Undefined type!');
      }
    }
  }
};
</script>
